import {
  Box,
  Button,
  FormGroup,
  FormLabel,
  Grid,
  MenuItem,
  Select,
  SelectChangeEvent,
  Typography,
} from "@mui/material";
import { useEffect, useState } from "react";
import "react-phone-input-2/lib/style.css";
import Swal from "sweetalert2";
import Services from "../../../../../api/services";

interface serviceEditProps {
  id: number;
  serviceStatus: string;
}

interface userDetailsProps {
  userData: any;
  setServiceData: (value: any) => void;
  handleClose: (value: boolean) => void;
}

const ServiceEdit: React.FC<userDetailsProps> = ({
  userData,
  setServiceData,
  handleClose,
}) => {
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [errors, setErrors] = useState<Partial<serviceEditProps>>({});
  const [formData, setFormData] = useState<serviceEditProps>({
    id: userData.id,
    serviceStatus: userData.serviceStatus,
  });

  const validateForm = () => {
    const newErrors: Partial<serviceEditProps> = {};
    if (!formData.serviceStatus.trim()) {
      newErrors.serviceStatus = "Service status is required";
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0; // Return true if there are no errors
  };

  const handleSelect = (event: SelectChangeEvent) => {
    const { name, value } = event.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
    setErrors((prevErrors) => ({ ...prevErrors, [name]: "" }));
  };

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (validateForm()) {
      setIsSubmitted(true);
      const bodyFormData = {
        id: formData.id,
        status: formData.serviceStatus,
      };

      try {
        const tokenString = localStorage.getItem("access_token");
        if (tokenString !== null) {
          const token = JSON.parse(tokenString);
          const options = {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          };

          const response = await Services.admin.updateServiceStatusService(
            bodyFormData,
            options
          );
          if (response.status === 200) {
            const serviceResponse = await Services.admin.getAllServiceData(
              options
            );
            setServiceData(serviceResponse.data.data);
            Swal.fire({
              title: "Thank You!",
              text: "Status updated successfully",
              icon: "success",
              confirmButtonColor: "#11b4f5",
            });
          }
          handleClose(false);
        }
      } catch (error: any) {
        if (
          error.response &&
          error.response.data &&
          error.response.data.message
        ) {
          Swal.fire({
            title: "Error!",
            text: `${error.response.data.message}`,
            icon: "error",
            confirmButtonColor: "#11b4f5",
          });
        } else {
          Swal.fire({
            title: "Error!",
            text: "An unexpected error occurred.",
            icon: "error",
            confirmButtonColor: "#11b4f5",
          });
        }
        console.error("Error during POST request:", error);
      } finally {
        setIsSubmitted(false);
      }
    } else {
      console.log("Form validation failed:", errors);
    }
  };
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Box sx={{ mt: 1 }}>
      <form onSubmit={handleSubmit}>
        <Grid container spacing={2}>
          <Grid item xs={12} lg={12}>
            <FormGroup>
              <FormLabel>Service Status</FormLabel>
              <Select
                fullWidth
                name="serviceStatus"
                value={formData.serviceStatus}
                displayEmpty
                defaultValue="Please select"
                label="serviceStatus"
                onChange={handleSelect}
                sx={{
                  "&.MuiInputBase-root": {
                    border: "1px solid #ccc",
                    backgroundColor: "#FFF",
                    height: "48px",
                    "@media (max-width: 992px)": {
                      width: "100%",
                    },
                  },
                  fieldset: {
                    display: "none",
                  },
                }}
              >
                <MenuItem value={""} disabled>
                  Please select
                </MenuItem>
                <MenuItem value="pending">Pending</MenuItem>
                <MenuItem value="approve">Approve</MenuItem>
                <MenuItem value="reject">Reject</MenuItem>
              </Select>
              {errors.serviceStatus && (
                <Typography color="error">{errors.serviceStatus}</Typography>
              )}
            </FormGroup>
          </Grid>
          <Grid item xs={12}>
            <Button variant="contained" type="submit" disabled={isSubmitted}>
              {isSubmitted ? (
                <span style={{ color: "#fff" }}>Submitting...</span>
              ) : (
                "Update"
              )}
            </Button>
          </Grid>
        </Grid>
      </form>
    </Box>
  );
};
export default ServiceEdit;
